import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BossItem } from '../models';

@Injectable()
export class BossService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {}

  public getItems(): Observable<{ items: BossItem[] }> {
    return this.httpClient.get<{ items: BossItem[] }>(
      `${this.apiBaseUrl}boss/reports`,
    );
  }

  public refresh(period: string): Observable<BossItem> {
    return this.httpClient.post<BossItem>(
      `${this.apiBaseUrl}boss/reports/${period}/refresh`,
      null,
    );
  }

  public download(period: string): Observable<ArrayBuffer> {
    return this.httpClient.get(
      `${this.apiBaseUrl}boss/reports/${period}/file`,
      {
        headers: new HttpHeaders({
          Accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
        responseType: 'arraybuffer',
      },
    );
  }
}
